import _ from 'lodash';
import React, {FC, useState} from 'react';
import Select from '../../../utils/select/Select';
// import Select from 'react-select';
import Tabs from '../../../utils/tabs/Tabs';

interface NewProjectLocationProps{
    domain: string;
    location: string;
    locationScope: string;
    updateLocation: (nextLocation:string)=>void;
    updateLocationScope: (nextScope: string) => void;
    defaultValue?: string;
}

const countryList = [{label: "Česko", value:"cze"}, {label: "Slovensko", value: "svk"}, {label: "Polsko", value: "pln"}];

const NewProjectLocation: FC<NewProjectLocationProps> = ({
    domain,
    location,
    locationScope,
    updateLocation,
    updateLocationScope,
    defaultValue
}) => {
// function NewProjectLocation({domain, location, locationScope, updateLocation, updateLocationScope, defaultValue}) {

    //API: aktuálné 3 znaky country (cze) nebo global
    // const countryList = [{label: "Česká Republika", value:"cze"}, {label: "Slovensko", value: "svk"}, {label: "Polsko", value: "pln"}];
    // const regionList = [{label: "Královehradecký kraj", value: "h"}, {label: "Pardubický kraj", value:"e"}, {label: "Hlavní město Praha", value: "A"}];
    // const cityList = [{label: "Pardubice", value:"pce"}, {label: "Hradec Králové", value: "hk"}, {label: "Praha", value: "prg"}];

    const [selectedLocation, setSelectedLocation] = useState(_.find(countryList, ["value", defaultValue])?.label);
    const scopeList = ["global", "country"];
    const [locationScopeIndex, setLocationScopeIndex] = useState(scopeList.indexOf(locationScope));

    // const locationList = {cze: "Česko", svk: "Slovensko", pln: "Polsko"};

    function updateSelected(selected:any){
        setSelectedLocation(selected.label);
        updateLocation(selected.value);
        // updateLocation({location: selected.value, scope: locationScope});
    }

    function newLocationScope(i:any){
        setLocationScopeIndex(i);
        updateLocationScope(scopeList[i])
    }


    return (
        <div className="project-new-inner project-new-location">
            <img className="illustration" src={process.env.PUBLIC_URL+"/imgs/illustrations/ProjectNewLocation.svg"} alt="illustration" />
            <h5 className="text-center">Je <span style={{color: "#F5B746"}} className="secondary">{selectedLocation}</span> lokací,<br/> na kterou <span className="secondary">{domain}</span> cílí?</h5>
            <div className="project-new-location-in">
                <Tabs
                    list={["Global", "Country"]}
                    active={locationScopeIndex}
                    setActive={newLocationScope}
                />
                {locationScope === "country" && 
                    <div>
                        <Select
                            className="search-select text-center"
                            placeholder="Vyberte oblast"
                            isLoading={false}
                            isSearchable={true}
                            optionSelected={_.find(countryList, ['value', location])}
                            // defaultValue={(locationScope==="country"?countryList[0]:
                            //     (locationScope==="region"?regionList[0]:
                            //     (locationScope==="city"?cityList[0]:[])))}
                            // name="location-selector"
                            // options={(locationScope==="country"?countryList:
                            //     (locationScope==="region"?regionList:
                            //     (locationScope==="city"?cityList:[])))}
                            optionList={countryList}
                            // optionSelected={"cze"}
                            onChange={updateSelected}
                        />
                    </div>
                }
            </div>
        </div>
    );
}

export default NewProjectLocation;